import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { LocalStorage, LocalStorageService, SessionStorage, SessionStorageService } from 'angular-web-storage';
import { environment } from '../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  deviceInfo = null;
  cydiaFacebook: string;
  saurikTwitter: string;
  contentList: any;

  appsRandomTop: any;
  appsRandomBottom: any;

  userCredential: any;
  accessPrivileges: any;

  appName: any;
  accessPriSpSource: string;
  accessPriSpSourceVal: string;

  upFilterArgs = {cont_cat_page_location: 'up'};

  constructor(
    private _appService: AppService,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();

    //this.deviceInfo = this.deviceService.getDeviceInfo();

    const iOsVersion = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);

    let lastDecimal;


    if (isNaN(parseInt(iOsVersion[3], 10))) {
      lastDecimal = '';
    } else {
      lastDecimal = '.' + parseInt(iOsVersion[3], 10);
    }

    lastDecimal = parseInt(iOsVersion[1], 10) + '.' + parseInt(iOsVersion[2], 10) + lastDecimal;
    this.deviceInfo = lastDecimal.toString();


    this.accessPrivileges = this.sessionStorage.get('accessPrivileges');
    this.userCredential = this.localStorage.get('sociaKey');

    this.getConfigDataServiceByPage('home').subscribe(res => {
      this.cydiaFacebook = res['conf_facebook_fan']['config_val'];
      this.saurikTwitter = res['conf_twitter_fan']['config_val'];
    });

    this.getConfigDataServiceByPage('all').subscribe(res => {
      this.appName = res['config_app_name']['config_val'];
      this.accessPriSpSource = res['config_cydia_sp_source_pri']['config_val'];
      this.accessPriSpSourceVal = res['config_cydia_sp_source_pri_val']['config_val'];
    });

    this._appService.getContentListByPageName('home').subscribe(res => {
      console.log(res);
      this.contentList = res;
    });

    if (this.accessPrivileges != null && this.userCredential != null && this.userCredential.userEmail != null) {
      this._appService.getUserData(this.userCredential.userEmail).subscribe(res => {
        this.sessionStorage.set('accessPrivileges', res['pri_val']);
        this.accessPrivileges = res['pri_val'];
      });

      this._appService.getRandomAppsHomePage(this.accessPrivileges).subscribe(res => {
        this.appsRandomTop = res['top'];
        this.appsRandomBottom = res['bottom'];
        this.spinner.hide();
      });

    } else {
      this._appService.getRandomAppsHomePageNoAccessPri().subscribe(res => {
        this.appsRandomTop = res['top'];
        this.appsRandomBottom = res['bottom'];
        this.spinner.hide();
      });
      this.sessionStorage.set('accessPrivileges', environment.appPrivilege);
      this.accessPrivileges = environment.appPrivilege;
    }

  }


  getConfigDataServiceByPage(pageName: string) {
    return this._appService.getConfigDataByPage(pageName);
  }


}
